module.exports = __webpack_public_path__ + "img/telegramIcon.a4e09cbe.svg";